import { useIntl } from '@doxyme/locale';
import { type RoomForPatient } from '../../services';
import { getProviderName } from '../../shared/getProviderName';

export const useRoomHostName = (
  waitingRoom?: RoomForPatient | null,
): string => {
  const { formatMessage } = useIntl();

  if (!waitingRoom) {
    return '';
  }

  if (!waitingRoom.isPersonal && !!waitingRoom.displayName) {
    return waitingRoom.displayName;
  }

  return (
    getProviderName({ ...waitingRoom.roomAdmin, formatMessage }) ||
    waitingRoom.name
  );
};
